import React, { Fragment } from "react";

export default (
  <>
    <path d="M12 15L6 9L18 9L12 15Z" />
  </>
);
